import React, { Component } from 'react'
import { connect } from 'react-redux'
import * as R from 'ramda'

import IconMenu from 'material-ui/IconMenu'
import MenuItem from 'material-ui/MenuItem'
import IconButton from 'material-ui/IconButton'
import ArrowDropDown from 'material-ui/svg-icons/navigation/arrow-drop-down'

import dataActions from 'actions/dataActions'
import { doc, dirtyRead } from 'selectors/common'
import { vendors } from 'selectors/entities'
import Section from 'components/Section'

const catsInvoice = [
	{name: "Rent", req: "#Income:Rent"},
	{name: "Deposit", req: "#Income:Deposit"},
	{name: "Fee", req: "#Income:Fee"},
	{name: "Expenses", req: "#Income:Expenses"}
]
const catsBill = [
	{subtype: "advertising", name: "Advertising", req: "70000 Property Expenses:70010 Advertising"},
	{subtype: "apps", name: "Appliances", req: "70000 Property Expenses:70020 Appliances"},
	{subtype: "cnm", name: "Cleaning and maintenance", req: "70000 Property Expenses:70030 Cleaning and maintenance"},
	{subtype: "hoa", name: "HOA fees", req: "70000 Property Expenses:70040 HOA fees"},
	{subtype: "insurance", name: "Insurance", req: "70000 Property Expenses:70050 Insurance"},
	{subtype: "legal", name: "Legal and Other fees", req: "70000 Property Expenses:70060 Legal and Other fees"},
	{subtype: "management", name: "Management fees", req: "70000 Property Expenses:70070 Management fees"},
	{subtype: "misc", name: "Miscellaneous", req: "70000 Property Expenses:70080 Miscellaneous"},
	{subtype: "loan", name: "Mortgage interest", req: "70000 Property Expenses:70090 Mortgage interest"},
	{subtype: "loan", name: "Mortgage principle", req: "70000 Property Expenses:70100 Mortgage principle"},
	{subtype: "repair", name: "Repair", req: "70000 Property Expenses:70110 Repair"},
	{subtype: "taxes", name: "Taxes", req: "70000 Property Expenses:70120 Taxes"},
	{subtype: "utilities", name: "Utilities", req: "70000 Property Expenses:70130 Utilities"}
]

let select = dirtyRead(
	(state, props) => ({
		transaction: doc(state, props.objectID)
	  , vendors: vendors(state)
	})
)

export class AddLineButton extends Component{
	render(){
		let { props } = this
		let menu = true
		let cats = props.transaction.type == "transaction/bill"? catsBill : catsInvoice
		return(
			<div className="button">
				<span
					style={{
						cursor: "pointer"
					  , color: props.color || "#5ae4c3"
					}}
					onClick={()=>{
						if (props.transaction.qbid) return false
						let lines = props.transaction.lines || props.transaction.expenses
						 let cat = lines.length ? lines[0].category : (props.vendors[props.transaction.vendorID].accountCategory)?props.vendors[props.transaction.vendorID].accountCategory:""
						 let i = R.findIndex(R.propEq('req', cat))(cats)
						 let newEl = {
						   category: cat,
						   categoryName: (i<0)?"":cats[i].name,
						   amount: "",
						   memo: "",
						 }
						 let newElN = {
						   category: cat,
						   categoryName: (i<0)?"":cats[i].name,
						   half: "N Mand",
						   amount: "",
						   memo: ""
						 }
						 let newElS = {
						   category: cat,
						   categoryName: (i<0)?"":cats[i].name,
						   half: "S Lubarsky",
						   amount: "",
						   memo: ""
						 }
						 let newExps = (props.transaction.bookID != "1476645611177")?
						   [...lines, newEl]
						   :
						   [...lines, newElN, newElS]
						 if (props.transaction.type == "transaction/bill"){
							 props.LINE_ADD({
								 _id: props.objectID
							   ,  expenses: newExps
							 })
						 }else{
							 props.LINE_ADD({
								 _id: props.objectID
							   ,  lines: newExps
							 })
						 }
					 }}
				>
				   <svg
						width="18px"
						height="25px"
						viewBox="0 0 24 24"
						version="1.1"
						xmlns="http://www.w3.org/2000/svg"
						xmlnsXlink="http://www.w3.org/1999/xlink"
						style={{
							verticalAlign: "middle"
						  , marginRight: "4px"
						  , marginTop: "-2px"
						}}
					>
						<title>Group 2</title>
						<defs></defs>
							<g id="Page-1" stroke={props.color || "#5ae4c3"} strokeWidth="2" fill="none" fillRule="evenodd">
								<g id="Group-2" transform="translate(1.000000, 1.000000)" stroke={props.color || "#5ae4c3"} strokeWidth="2">
								<path d="M11,4.5 L11,17.5" id="Line" strokeLinecap="square"></path>
								<path d="M5,11 L17,11" id="Line" strokeLinecap="square"></path>
								<circle id="Oval-1" cx="11" cy="11" r="11"></circle>
							</g>
						</g>
					</svg>
					<span style={{borderBottom: "dotted 2px " +  (props.color || "#5ae4c3")}}>NEW</span>
				</span>
				{props.children && <IconMenu
					iconButtonElement={<IconButton style={{padding:"0", height:"25px", width:"25px"}}><ArrowDropDown style={{padding:"0"}} color={props.color || "#5ae4c3"}/></IconButton>}
					anchorOrigin={{horizontal: 'left', vertical: 'top'}}
					targetOrigin={{horizontal: 'left', vertical: 'top'}}
					onItemTouchTap={(event, obj)=>{props.ADD(obj.props.object)}}
					style={{
						verticalAlign: "middle"
					  , padding:"0"
					}}
				>
					{props.children}
				</IconMenu>}
			</div>
		)
	}
}
export default connect(select, dataActions)(AddLineButton)



// WEBPACK FOOTER //
// ./src/routes/landlord/transactionForm/AddLineButton.js